import { toast, ToastOptions } from 'react-toastify';
import { t } from 'i18next'
import isObject from 'isobject';

interface IResponse {
    response: any,
    success: [string, {[key: string]: ToastOptions}?]
}

export default function responseNotify({response, success = ['Успех!']}:IResponse) {
    const error = response?.data?.error
    const incomplete = response?.data?.incomplete

    if (response?.status===200) 
        toast.success(t(success[0], success[1]))

    else if (error && !isObject(error)) {
        toast.error(t(`Store.response.${error}`))
        return {incomplete}!
    }

    else if (error && isObject(error)) {
        Object.keys(error).map((e:any) => {
            toast.error(<div className='flex-column'>
                {t('Store.response.insufficient_param')}
                <strong>{t(`Store.params.${e}`)}</strong>
            </div>)
        })
    }
    
    else if (response?.status===503)
        toast.error(t(`popup.maintenance`))

    else if (response?.status===400) 
        toast.error(t('popup.error'))

    else toast.error(t('popup.connectionLost'))
}